// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"834":"c1774bbefe790c906856","926":"90c63f89bf5aaf79313b"}[chunkId] + ".chunk.js";
};